
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import {
  FaHome,
  FaInfoCircle,
  FaUsers,
  FaPhoneAlt,
  FaFileAlt
} from "react-icons/fa";

import b from "../img/logo.png";
import tttttt from "../img2/hai.png";

const Footer = styled.footer`
  width: 100%;
  background: #081a2f;
  color: #fff;
  direction: rtl;
  text-align: center;
  box-sizing: border-box;
  padding: 55px 22px 0;

  .footer-inner {
    max-width: 1150px;
    margin: 0 auto;
  }

  .logo-area {
    margin-bottom: 22px;
  }

  .logo {
    width: 280px;
    max-width: 85%;
    height: auto;
    object-fit: contain;
  }

  .footer-description {
    max-width: 700px;
    margin: 0 auto 42px;
    color: rgba(255,255,255,.72);
    font-size: 14px;
    line-height: 2.1;
    font-weight: 400;
  }

  .footer-navigation {
    max-width: 380px;
    margin: 0 auto 42px;
    padding: 28px 30px;
    text-align: right;
    background: rgba(255,255,255,.035);
    border: 1px solid rgba(255,255,255,.09);
    border-radius: 12px;
    box-shadow: 0 8px 25px rgba(0,0,0,.10);
  }

  .footer-heading {
    position: relative;
    font-size: 18px;
    font-weight: 800;
    color: #fff;
    margin: 0 0 23px;
    padding-bottom: 14px;
  }

  .footer-heading::after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 0;
    width: 42px;
    height: 3px;
    background: #0693e3;
    border-radius: 5px;
  }

  .footer-nav {
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .footer-nav a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 13px;
    min-height: 46px;
    padding: 8px 2px;
    color: rgba(255,255,255,.78);
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    border-bottom: 1px solid rgba(255,255,255,.075);
    transition: color .22s ease, padding-right .22s ease;
  }

  .footer-nav a:last-child {
    border-bottom: none;
  }

  .footer-nav a svg {
    width: 17px;
    min-width: 17px;
    font-size: 15px;
    color: #0693e3;
    transition: transform .22s ease;
  }

  .footer-nav a:hover {
    color: #fff;
    padding-right: 8px;
  }

  .footer-nav a:hover svg {
    transform: scale(1.12);
  }

  .footer-bottom {
    border-top: 1px solid rgba(255,255,255,.12);
    padding: 23px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
  }

  .copyright {
    color: rgba(255,255,255,.65);
    font-size: 12px;
    line-height: 2;
    text-align: right;
  }

  .copyright strong {
    color: #fff;
    font-size: 13px;
    font-weight: 700;
  }

  .credit {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }

  .credit img {
    width: 155px;
    height: auto;
    object-fit: contain;
  }

  .credit a {
    color: rgba(255,255,255,.8);
    font-size: 12px;
    text-decoration: none;
    transition: color .2s ease;
  }

  .credit a:hover {
    color: #0693e3;
  }

  @media (max-width: 650px) {
    padding: 38px 16px 0;

    .logo {
      width: 235px;
    }

    .footer-description {
      font-size: 13px;
      margin-bottom: 30px;
    }

    .footer-navigation {
      width: 100%;
      max-width: 380px;
      padding: 24px 20px;
      margin-bottom: 30px;
      box-sizing: border-box;
    }

    .footer-heading {
      font-size: 17px;
    }

    .footer-nav a {
      font-size: 13px;
      min-height: 44px;
    }

    .footer-bottom {
      flex-direction: column;
      justify-content: center;
      gap: 18px;
    }

    .copyright {
      text-align: center;
    }

    .credit {
      flex-wrap: wrap;
    }

    .credit img {
      width: 135px;
    }
  }
`;

export const Navigationdowen = () => {
  return (
    <Footer>
      <div className="footer-inner">
        <div className="footer-navigation">
          <h3 className="footer-heading">ניווט מהיר</h3>

          <nav className="footer-nav" aria-label="ניווט מהיר">
            <Link to="/">
              <FaHome />
              דף הבית
            </Link>

            <Link to="/about">
              <FaInfoCircle />
              אודות
            </Link>

            <Link to="/customers">
              <FaUsers />
              לקוחותינו
            </Link>

            <Link to="/contact">
              <FaPhoneAlt />
              יצירת קשר
            </Link>

            <a
              href="/תקנון-שימוש-באתר - רישוי עסקים ישראל.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFileAlt />
              תקנון האתר
            </a>
          </nav>
        </div>
        <div className="logo-area">
          <img
            src={b}
            alt="רישוי עסקים ישראל"
            className="logo"
          />
        </div>

        <p className="footer-description">
          רישוי עסקים ישראל מעניקה מידע ושירותים מקצועיים
          בתחום רישוי העסקים, תוך הקפדה על מקצועיות,
          אמינות ומתן מענה מותאם לצורכי בעלי העסקים.
        </p>



        <div className="footer-bottom">
          <div className="copyright">
            <strong>© רישוי עסקים ישראל 2026</strong>
            <br />
            כל הזכויות שמורות. אין להעתיק או לעשות שימוש
            בתכני האתר ללא אישור מראש ובכתב.
          </div>

          <div className="credit">
            <a
              href="https://siteb2b.co.il/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={tttttt} alt="SITE B2B" />
            </a>

            <a
              href="https://siteb2b.co.il/"
              target="_blank"
              rel="noopener noreferrer"
            >
              פיתוח ובניית האתר: SITE B2B
            </a>
          </div>
        </div>

      </div>
    </Footer>
  );
};

export default Navigationdowen;
